import "./_application.js.coffee";

import "./_shared.js.coffee";
import "./lib/helpers";
import "./tixxt/concerns.js.coffee";
import "./tixxt/_shared";
import "./tixxt/_templates";
import "./tixxt/embedded_collection_builder.js.coffee";
import "./tixxt/embedded_model_builder.js.coffee";
import "./tixxt/feature_controller.js.coffee";
import "./tixxt/feature_layout.js.coffee";
import "./tixxt/filtered_collection.js.coffee";
import "./tixxt/lightbox.js.coffee";
import "./tixxt/model_binding.js.coffee";
import "./tixxt/recoverable_error.js.coffee";
import "./config/index";
import "./administration/config.js.coffee";
import "./directory/config.js.coffee";
import "./files/config.js.coffee";
import "./invites/config.js.coffee";
import "./tasks/config.js.coffee";

import "./tixxt/models.js.coffee";
import "./preload.js.coffee";

export default window.Tixxt;
